import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appConsentAnswer]',
})
export class ConsentAnswerDirective implements AfterViewInit {
  private el = inject(ElementRef);


  public ngAfterViewInit(): void {
    this.recalculate();
    window.addEventListener('orientationchange', () => this.recalculate());
    window.addEventListener('resize', () => this.recalculate());
  }

  public recalculate(): void {
    const labels = this.el.nativeElement.querySelectorAll('.consent-yes, .consent-no');
    const heights = Array.from<HTMLElement>(labels).map((label: HTMLElement) => label.getBoundingClientRect().height);
    let maxHeight = Math.max(...heights);
    const elNoAltText = this.el.nativeElement.querySelector('.consent-alt-no');

    if (elNoAltText) {
      maxHeight = Math.max(maxHeight, elNoAltText.getBoundingClientRect().height);
      elNoAltText.style.height = `${maxHeight}px`;
    }

    labels.forEach(label => {
      label.style.height = `${maxHeight}px`;
    });

  }
}
